
import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";




export function Recipes () {
	const [manifest,updateManifest] = useState ( null )
	
	useEffect ( () => {
		fetch ( '/Recipes/Manifest.json' )
		.then ( response => response.json() )
		.then ( response => updateManifest(response) )
		.catch(error => console.error('Error fetching data:', error));
	} , [] )
	
	useEffect ( () => {
		document.title = "Recipes"
	} , [] )
	
	if ( manifest == null ) {
		return (
			<p>Loading...</p>
		)
	}
	
	const divStyle = {
		margin: '20px' ,
	}
	const linkStyle = {
		textDecoration: 'none' ,
		fontSize: '120%' ,
	}
	
	return (
		<div style={divStyle}>
			{
				manifest.map ( item => (
					<p key={item['Key']}>
						<Link
							style={linkStyle}
							to={`/Recipes/${item['Key']}`}
							target="_self"
							key={item['Key']}
						>
							{item['Title']}
						</Link>
					</p>
				))
			}
		</div>
	)
}

export function Recipe () {
	const {recipeLabel} = useParams()
	
	const [recipe,updateRecipe] = useState ( null )
	
	
	useEffect ( () => {
		let path = `/Recipes/${recipeLabel}.json`
		//console.log ( path )
		fetch ( path )
		.then ( response => response.json() )
		.then ( response => updateRecipe(response) )
		.catch(error => console.error('Error fetching data:', error));
	} , [] )
	
	useEffect ( () => {
		document.title = recipe==null ? "Loading Recipe" : `${recipe['Title']} Recipe`
	} , [recipe] )
	
	
	if ( recipe == null ) {
		return (
			<p>Loading...</p>
		)
	}
	
	let name = recipe['Title']
	
	
	if ( recipe == null ) {
		return (
			<p>Error with {name}!</p>
		)
	}
	
	const divStyle = {
		margin: "4px" ,
	}
	const titleStyle = {
		fontSize: "150%" ,
		fontWeight: "bold" ,
		marginBottom: "8px" ,
	}
	const descriptionStyle = {
		marginTop: "8px" ,
		marginLeft: "10px" ,
		marginRight: "10px" ,
		fontSize: "90%" ,
	}
	
	const sourceLinkStyle = {
		color: 'grey' ,
		textDecoration: 'none' ,
	}
	
	
	return (
		<div style={divStyle}>
			<p style={titleStyle}>
				{name}
			</p>
			<p style={descriptionStyle}>
				{recipe['Description']}
			</p>
			{recipe['SourceURL']&&(
				<p style={descriptionStyle}>
					<a href={recipe['SourceURL']} style={sourceLinkStyle} target="_blank">Click for original recipe & author's life story</a>
				</p>
			)}
			{recipe['Steps'].map ( (step,index) => (
				<RecipeStep step={step} key={step['UUID']}/>
			))}
		</div>
	)
}

function RecipeStep ({ step }) {
	let [checkedStati,setCheckedStati] = useState ( {} )
	let isChecked = checkedStati['_root'] ? true : false
	
	function didCheck ( ev ) {
		setCheckedStati ( cur => ({
			...cur ,
			'_root' : !cur['_root'] ,
		}))
	}
	
	
	const divStyle = {
		marginLeft: "10px" ,
		marginTop: "10px" ,
		marginBottom: "10px" ,
		paddingLeft: "4px" ,
		paddingTop: "2px" ,
		paddingBottom: "2px" ,
		//borderLeft: "blue solid 1px" ,
	}
	
	const instructionPStyle = {
		fontSize: "110%" ,
		marginTop: "2px" ,
		
		marginBottom: "4px" ,
	}
	const actionSpanStyle = {
		textTransform: "capitalize" ,
		fontWeight: "bold" ,
		color: isChecked ? "grey" : "blue" ,
	}
	const articleSpanStyle = {
		fontSize: "90%" ,
		color: isChecked ? "grey" : "darkgrey" ,
	}
	const targetSpanStyle = {
		//textTransform: "capitalize" ,
		fontWeight: "bold" ,
		color: isChecked ? "grey" : "darkblue" ,
	}
	
	const itemsDivStyle = {
		marginLeft: "30px" ,
	}
	
	const durationPStyle = {
		fontSize: "90%" ,
		marginTop: "2px" ,
		
		marginBottom: "4px" ,
		marginLeft: "20px" ,
		color: isChecked ? "grey" :"darkred" ,
	}
	
	return (
		<div style={divStyle}>
			<p style={instructionPStyle}>
				<input type="checkbox" onChange={didCheck} checked={isChecked}/>
				&nbsp;
				<span style={actionSpanStyle}>{step["Action"]}</span>
				&nbsp;
				<span style={articleSpanStyle}>{step["Article"]}</span>
				&nbsp;
				<span style={targetSpanStyle}>{step["Target"]}</span>
			</p>
			{
				( step['Duration'] != null ) && <p style={durationPStyle}>
					{step['Duration']}
				</p>
			}
			{
				( !isChecked && step['Items'] != null ) && <div style={itemsDivStyle}>
					{
						step["Items"].map ( (item,i) => (
							<RecipeItem
							item={item}
							checkedStati={checkedStati}
							setCheckedStati={setCheckedStati}
							key={item['UUID']}
							/>
						))
					}
				</div>
			}
		</div>
	)
}


function RecipeItem ({ item , checkedStati,setCheckedStati }) {
	let uid = item['UUID']
	let isChecked = checkedStati[uid] ? true : false
	
	function didCheck ( ev ) {
		setCheckedStati ( cur => ({
			...cur ,
			[uid] : !cur[uid] ,
		}))
	}
	
	
	const pStyle = {
		fontSize: "110%" ,
		marginTop: "12px" ,
		
		marginBottom: "4px" ,
	}
	
	const nameSpanStyle = {
		color: "darkblue" ,
		fontWeight: "bold" ,
	}
	
	const noteStyle = {
		fontSize: "80%" ,
		color: 'grey' ,
		marginTop: '2px' ,
		marginLeft: '30px' ,
	}
	const linkStyle = {
		textDecoration: 'none' ,
	}
	
	return (
		<div>
			<p style={pStyle}>
				<input type="checkbox" onChange={didCheck} checked={isChecked}/>
				&nbsp;
				<span style={nameSpanStyle}>{item["Name"]}</span>
				{
					( !isChecked && item['Amount'] != null ) && (
						<ItemAmount
							amounts={item['Amount']}
						/>)
				}
			</p>
			{
				( item['URL'] != null ) && (
					<p style={noteStyle}>
						<a style={linkStyle} href={item['URL']} target='_blank'>Link to source</a>
					</p>
				)
			}
		</div>
	)
}

function ItemAmount ({ amounts }) {
	let akaStyle = {
		marginLeft: "8px" ,
		marginRight: "6px" ,
		color: "grey" ,
		fontSize: "75%" ,
	}
	let arrowStyle = {
		marginLeft: "8px" ,
		marginRight: "8px" ,
		color: "grey" ,
	}
	let spanStyle = {
		//marginLeft: "10px" ,
		fontSize: "80%" ,
	}
	
	let uid = amounts['UUID']
	
	let keys = Object.keys(amounts).filter ( item => item != 'UUID' )
	keys.sort()
	let rval = []
	keys.forEach ( (key,i) => {
		if ( i )
			rval.push ( <span style={akaStyle} key={`${uid}/${key}/aka`}>aka</span> )
		else
			rval.push ( <span style={arrowStyle} key={`${uid}/${key}/arrow`}>&rarr;</span>)
		rval.push ( <SpecificAmount value={amounts[key]} units={key} key={`${uid}/${key}`}/> )
	})
	return (
		<span style={spanStyle}>
			{rval}
		</span>
	)
}
function SpecificAmount ({ value , units }) {
	let overallStyle = {
		//color: ( units == "Tbsp" ? "#660066" : "#660000" ) ,
		fontWeight: "bold" ,
	}
	let valueStyle = {
		color: ( units == "Tbsp" ? "#660066" : "#660000" ) ,
	}
	let unitsStyle = {
		color: ( units == "Tbsp" ? "#660066" : "#660000" ) ,
	}
	return (
		<span style={overallStyle}>
			<span style={valueStyle}>{value}</span>
			&nbsp;
			<span style={unitsStyle}>{units}</span>
		</span>
	)
}
